export function convertToCSV(objArray) {
  const array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
  let str = '';

  for (let i = 0; i < array.length; i++) {
    let line = '';
    for (const index in array[i]) {
      // console.log(array[i][index]);
      if (line != '') line += ',';

      line += array[i][index];
    }

    str += `${line}\r\n`;
  }

  return str;
}

export default function exportToCsv(headers, items) {
  if (headers) {
    items.unshift(headers);
  }

  // Convert Object to JSON
  const jsonObject = JSON.stringify(items);

  const csv = convertToCSV(jsonObject);

  return csv;
}

export function exportToCsvV2(headers, items) {
  const keys = Object.keys(headers);
  let str = '';
  for (const key of keys) {
    str += headers[key];
    if (key !== keys[keys.length - 1]) str += ',';
  }
  str += '\r\n';

  for (const item of items) {
    let line = '';
    for (const key of keys) {
      if (line !== '') line += ',';

      line += item[key];
    }

    str += `${line}\r\n`;
  }

  return str;
}

export function saveCsv(csv, fileTitle) {
  const exportedFilenmae = `${fileTitle}.csv` || 'export.csv';

  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  if (navigator.msSaveBlob) { // IE 10+
    navigator.msSaveBlob(blob, exportedFilenmae);
  } else {
    const link = document.createElement('a');
    if (link.download !== undefined) { // feature detection
      // Browsers that support HTML5 download attribute
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', exportedFilenmae);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/exportToCsv.js